import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { ConfirmModal } from "../../../../../../shared/components/dialogs/ConfirmModal"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { AccountingCustomReportsQuery, updateCustomJob } from "../customReportsApi"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { CustomJob } from "../customReportsTypes"

type UpdateCustomJobDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    item: CustomJob
}>

export function UpdateCustomJobDialog({ onClose, open, item }: UpdateCustomJobDialogProps) {
    const { l10n } = useAppLocalization()

    const { mutate: callUpdateCustomJob } = useApiMutation(updateCustomJob, {
        async onSuccess(_params, _data, context) {
            await context.queryClient.invalidateQueries({
                queryKey: [AccountingCustomReportsQuery.CUSTOM_REPORTS_LIST],
            })
        },
    })

    const isActive = item?.isActive
    const actionKey = isActive
        ? "merchant-accounting-custom-reports-table-button-deactivate"
        : "merchant-accounting-custom-reports-table-button-activate"
    const actionLabel = isActive ? "Deactivate" : "Activate"

    const confirmationMessage = l10n.getString("merchant-accounting-custom-reports-confirm-modal-question", {
        status: l10n.getString(actionKey),
        itemName: item.name,
    })

    return (
        <ConfirmModal
            title={
                <LocalizedStrict id={actionKey}>
                    <>{actionLabel}</>
                </LocalizedStrict>
            }
            message={confirmationMessage}
            handleClick={() =>
                callUpdateCustomJob({
                    jobId: item.id,
                    isActive: !isActive,
                })
            }
            buttonLabelSubmit={l10n.getString(actionKey)}
            open={open}
            onClose={onClose}
        />
    )
}
